import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { wakeApi } from "@/lib/wakeApi";
import { installGlobalErrorReporting } from "@/lib/reportSignal";
import { installToastLog } from "@/lib/toastLog";

wakeApi(); // avant le rendu : chaque chargement complet (app, /login, retour de connexion) réveille l'API
installGlobalErrorReporting(); // cf-677 : erreurs hors React vers les Remontées (connecté seulement)
installToastLog(); // chaque popup est aussi gardée pour être relue (cloche → Messages récents)

// Sélecteur d'applis Inevitable (hub, cf-55n) : une languette au bord gauche, servie par le hub. Vide
// (défaut, prod) = rien n'est chargé ; en local : REACT_APP_HUB_SWITCHER_URL dans .env.development.local.
const switcherUrl = process.env.REACT_APP_HUB_SWITCHER_URL;
if (switcherUrl) {
  const tag = document.createElement("script");
  tag.src = switcherUrl;
  tag.async = true;
  tag.dataset.app = "studio";
  tag.dataset.top = "75%";   // bande vide de la barre latérale : ne couvre aucun bouton (mesuré par Auth)
  // icône d'onglet (jimmy-wvw) : vide = marque Inevitable seule ; « badge » = marque + pastille de l'appli
  if (process.env.REACT_APP_HUB_TAB_ICON) tag.dataset.tabIcon = process.env.REACT_APP_HUB_TAB_ICON;
  document.body.appendChild(tag);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
